import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import HeaderDashboard from "./HeaderDashboard";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../Preloader";
import LoginView from "../Login/LoginView";
// import "~@flaticon/flaticon-uicons/css/all/all";
// import "../../../../public/assets/css/style.css"
//  import "../../../assets/css/styleVt.css"
//  import "../../../assets/css/bootsnav.css"

export default function Dashboard() {
  const navigate = new useNavigate();
  const cookies = new Cookies();
  const [Auth, SetAuth] = useState();

  const [showComponent, setShowComponent] = useState(false); // State to manage delay

  useEffect(() => {
    import("../Css/styleVt.css");
    import("../Css/bootsnav.css");

    // Delay for 1 second before showing the component
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 200);
  });

  useEffect(() => {
    SetAuth(cookies.get("token"));
    setTimeout(() => {
      $("#preloader").hide();
    }, 2000);
  });

  if (!showComponent) {
    return null; // Or return a loading spinner, etc.
  }

  return Auth ? (
    <>
      <Preloader />

      <HeaderDashboard />
      {/* Star Services Area
    ============================================= */}
      <div className="torch-red services-area default-padding bottom-less">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4>EMC Gear</h4>
                <h2>Dashboard</h2>
                <div className="devider" />
              </div>
            </div>
          </div>
        </div>
        <div className="container-full">
          <div className="services-items">
            <div className="row">
              {/* Single Item */}
              <div className="col-lg-3 col-md-6 single-item">
                <a href="/HomeBanner">
                  <div className="item">
                    <div className="info">
                      <i className="fi fi-tr-sign-posts-wrench"></i>
                      <h4>Home Banners</h4>
                      <div className="bottom">{/* <span>01</span> */}</div>
                    </div>
                  </div>
                </a>
              </div>
              {/* End Single Item */}
              {/* Single Item */}
              <div className="col-lg-3 col-md-6 single-item">
                <a href="/ProductList">
                  <div className="item">
                    <div className="info">
                      {/* <i className="flaticon-target" /> */}
                      <i class="fi fi-ts-supplier-alt"></i>
                      <h4>Products</h4>
                      <div className="bottom">{/* <span>02</span> */}</div>
                    </div>
                  </div>
                </a>
              </div>
              {/* End Single Item */}
              {/* Single Item */}
              <div className="col-lg-3 col-md-6 single-item">
                <a href="/Enquiry">
                  <div className="item">
                    <div className="info">
                      {/* <i className="flaticon-trophy" /> */}

                      <i class="fi fi-tr-target-audience"></i>
                      <h4>Enquiry</h4>
                      <div className="bottom">{/* <span>03</span> */}</div>
                    </div>
                  </div>
                </a>
              </div>
              {/* End Single Item */}
              {/* Single Item */}
              <div className="col-lg-3 col-md-6 single-item">
                <a href="/NewsLetter">
                  <div className="item">
                    <div className="info">
                      {/* <i className="flaticon-market-research" /> */}
                      <i class="fi fi-tr-newspaper"></i>
                      <h4>News Letter</h4>
                      <div className="bottom">{/* <span>04</span> */}</div>
                    </div>
                  </div>
                </a>
                -
              </div>
              {/* End Single Item */}
              {/* Single Item */}
              <div className="col-lg-3 col-md-6 single-item">
                <a href="/Category">
                  <div className="item">
                    <div className="info">
                      {/* <i className="flaticon-trophy" /> */}
                      <i class="fi fi-ts-category"></i>
                      <h4>Category</h4>
                      <div className="bottom">{/* <span>03</span> */}</div>
                    </div>
                  </div>
                </a>
              </div>
              {/* End Single Item */}

              {/* Single Item */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/Events">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-market-research" />
                      <h4>Latest Events</h4>
                      <div className="bottom">
                        <span>04</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* End Single Item */}

              {/* Single Item */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/AdminCareer">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-target-1" />
                      <h4>Careers</h4>
                      <div className="bottom">
                        <span>05</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* End Single Item */}
              {/* Single Item */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/AdminTerms">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-analytic" />
                      <h4>Terms</h4>
                      <div className="bottom">
                        <span>03</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* End Single Item */}
              {/* Single Item */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/AdminPrivacy">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-award-symbol" />
                      <h4>Privacy & Policy</h4>
                      <div className="bottom">
                        <span>04</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* End Single Item */}
              {/* Single Item */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/AdminFaq">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-question" />
                      <h4>FAQ</h4>
                      <div className="bottom">
                        <span>08</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* End Single Item */}
              {/* Single Item */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/ContactListTable">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-conversation" />
                      <h4>Inquiries</h4>
                      <div className="bottom">
                        <span>05</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/clients">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-trophy" />
                      <h4>Clients</h4>
                      <div className="bottom">
                        <span>10</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-3 col-md-6 single-item">
                <a href="/H1B_Appliers">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-target-1" />
                      <h4>H1B Appliers</h4>
                      <div className="bottom">
                        <span>11</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/EmailTemplateList">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-email" />
                      <h4>Email Templates</h4>
                      <div className="bottom">
                        <span>06</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* <div className="col-lg-3 col-md-6 single-item">
                <a href="/ApplicationConfig">
                  <div className="item">
                    <div className="info">
                      <i className="flaticon-analytic" />
                      <h4>Email Config</h4>
                      <div className="bottom">
                        <span>07</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div> */}
              {/* End Single Item */}
            </div>
          </div>
        </div>
      </div>
      {/* End Services Area */}
      {/* Start Footer 
    ============================================= */}
      <footer className="bg-dark text-light">
        {/* Start Footer Bottom */}
        <div className="footer-bottom">
          <div className="container">
            <div className="footer-bottom-box">
              <div className="row">
                <div className="col-lg-12">
                  <p className="mb-md-0 text-center  text-secondary">
                    © <a className="text-primary" href="#"></a>{" "}
                    Copyright {new Date().getFullYear()} All Rights Reserved by
                    <a
                      className="text-primary"
                      href="https://emcgear.in/"
                      style={{ paddingLeft: "5px" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      EMC Gear.
                    </a>{" "}
                    Powered by{" "}
                    <a
                      className="text-primary"
                      href="https://vaanamtech.com/"
                      style={{ paddingLeft: "5px" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Vaanam Technologies Pvt Ltd.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop smooth color="#2b5690" />
        {/* End Footer Bottom */}
      </footer>
      {/* End Footer */}
      {/* jQuery Frameworks
    ============================================= */}
    </>
  ) : (
    <LoginView />
  );
}
